import { SUPERSET_SDK_URL } from './constants';
import { SupersetSdkResult } from './types';

export function loadSupersetSdk(): Promise<SupersetSdkResult> {
  if (typeof window !== 'undefined' && window.supersetEmbeddedSdk) {
    return Promise.resolve({ sdk: window.supersetEmbeddedSdk, script: null });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SUPERSET_SDK_URL;
    script.async = true;
    script.onload = () => {
      if (window.supersetEmbeddedSdk) {
        resolve({ sdk: window.supersetEmbeddedSdk, script });
      } else {
        script.remove();
        reject(new Error('Superset Embedded SDK did not attach to window'));
      }
    };
    script.onerror = () => {
      script.remove();
      reject(new Error('Failed to load Superset Embedded SDK'));
    };
    document.body.appendChild(script);
  });
}
